'use strict';

( function ( $ ) {
	$( document ).on( 'click', '.form-modal-btn', function ( e ) {
		e.preventDefault();
		$( '.form-modal__overlay' ).fadeIn( '100' );
		$( 'body' ).css( 'overflow', 'hidden' );
	} );

	$( document ).on( 'click', '.form-modal__close', function () {
		const $modalOverlay = $( this ).closest( '.form-modal__overlay' );
		$modalOverlay.fadeOut( '100' );
		$( 'body' ).css( 'overflow', 'auto' );
	} );

	$( document ).on( 'click', '.form-modal__overlay', function ( e ) {
		if ( $( e.target ).hasClass( 'form-modal__overlay' ) ) {
			$( this ).fadeOut( '100' );
			$( 'body' ).css( 'overflow', 'auto' );
		}
	} );

	// Privacy toggle functionality
	$( document ).on( 'click', '.form-modal__privacy-open', function ( e ) {
		e.preventDefault();
		const $privacyToggle = $( this );
		const $privacyContent = $( '.form-modal__privacy-content' );

		$privacyToggle.toggleClass( 'active' );
		$privacyContent.toggleClass( 'active' );
	} );

	$( document ).on( 'click', '.form-modal__privacy-close', function () {
		const $privacyToggle = $( '.form-modal__privacy-open' );
		const $privacyContent = $( '.form-modal__privacy-content' );

		$privacyToggle.removeClass( 'active' );
		$privacyContent.removeClass( 'active' );
	} );
} )( jQuery );
